// extracted by mini-css-extract-plugin
export default {"component":"New_KeyboardComponent_component__EgsM2","line":"New_KeyboardComponent_line__6AUPY"};